import type { ReactNode } from "react";

/** The cockpit's icons: inline stroke SVG in the text colour, decorative unless labelled by their button. */

function Icon({ size = 16, fill = false, children }: { size?: number; fill?: boolean; children: ReactNode }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill ? "currentColor" : "none"}
      stroke={fill ? "none" : "currentColor"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {children}
    </svg>
  );
}

export const BackIcon = () => (
  <Icon>
    <path d="M15 18l-6-6 6-6" />
  </Icon>
);

export const EyeIcon = () => (
  <Icon size={15}>
    <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z" />
    <circle cx="12" cy="12" r="3" />
  </Icon>
);

export const CameraIcon = ({ size = 18 }: { size?: number }) => (
  <Icon size={size}>
    <path d="M23 7l-7 5 7 5V7z" />
    <rect x="1" y="5" width="15" height="14" rx="2" />
  </Icon>
);

export const MoreIcon = ({ size = 18 }: { size?: number }) => (
  <Icon size={size} fill>
    <circle cx="5" cy="12" r="2" />
    <circle cx="12" cy="12" r="2" />
    <circle cx="19" cy="12" r="2" />
  </Icon>
);

export const CheckIcon = () => (
  <Icon>
    <path d="M20 6L9 17l-5-5" />
  </Icon>
);

export const PlayIcon = ({ size = 16 }: { size?: number }) => (
  <Icon size={size} fill>
    <path d="M6 4l14 8-14 8V4z" />
  </Icon>
);

export const UpIcon = () => (
  <Icon size={14}>
    <path d="M12 19V5M5 12l7-7 7 7" />
  </Icon>
);

export const DownIcon = () => (
  <Icon size={14}>
    <path d="M12 5v14M19 12l-7 7-7-7" />
  </Icon>
);

export const RestartIcon = () => (
  <Icon>
    <path d="M1 4v6h6M23 20v-6h-6" />
    <path d="M20.5 9A9 9 0 005.6 5.6L1 10M23 14l-4.6 4.4A9 9 0 013.5 15" />
  </Icon>
);

export const KeyIcon = () => (
  <Icon>
    <path d="M21 2l-2 2m-7.6 7.6a5.5 5.5 0 11-7.8 7.8 5.5 5.5 0 017.8-7.8zm0 0L19 4m-3 3l3 3" />
  </Icon>
);

export const StopIcon = () => (
  <Icon>
    <rect x="5" y="5" width="14" height="14" rx="2" />
  </Icon>
);

export const WarnIcon = () => (
  <Icon>
    <path d="M12 9v4M12 17h.01M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z" />
  </Icon>
);

export const MicIcon = () => (
  <Icon size={22}>
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5 11a7 7 0 0014 0M12 18v3" />
  </Icon>
);

export const MicOffIcon = () => (
  <Icon size={22}>
    <path d="M15 9.3V6a3 3 0 00-5.7-1.3M9 9v2a3 3 0 004.9 2.3M5 11a7 7 0 0011.3 5.5M19 11a7 7 0 01-.6 2.8M12 18v3M3 3l18 18" />
  </Icon>
);
